import api from '../../../api/_analyse'

export default {
    getAnalysesEnSalleAttente(data) {
        return new Promise((resolve, reject) => {
            api.getAnalysesEnSalleAttente(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListePatientAnalyseToFill(data) {
        return new Promise((resolve, reject) => {
            api.getListePatientAnalyseToFill(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }

            )
        })
    },

    getRegistreAnalyse(data) {
        return new Promise((resolve, reject) => {
            api.getRegistreAnalyse(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }

            )
        })
    },

    getDistinctAnalyse(data) {
        return new Promise((resolve, reject) => {
            api.getDistinctAnalyse(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }

            )
        })
    },

    getListeAnalyseByCategory(data) {
        return new Promise((resolve, reject) => {
            api.getListeAnalyseByCategory(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }

            )
        })
    },
}